import { nanoid } from 'nanoid'
import { fireApiGet, get } from './api'

interface SuccessList {
  tenantInfo?: TenantInfo[]
  message: string
}

interface TenantInfo {
  tenantData: TenantData
  domains?: string[]
  type: 'Organization'
}

interface TenantData {
  tenantId: string
  cluster: string
  subdomain: string
}

export const tenantService = {
  getTenantIdFromSubdomain(subdomain: string) {
    return fireApiGet(`api/tenant/v1/public/tenants?subdomain=${subdomain}`, {
      headers: {
        'x-request-id': nanoid(),
      },
    })
      .json<SuccessList>()
      .then(({ tenantInfo }) => tenantInfo?.[0]?.tenantData.tenantId)
      .catch(err => {
        console.error(err)
        return get(`tenant-by-subdomain/${subdomain}`)
          .json<string>()
          .then(tenantId => tenantId)
      })
  },
}
